<table class="w-100">
  <ng-container *ngIf="(routeEditMode$ | async) === routeEditModeEnum.AddStop">
    <!-- Search row -->
    <tr
      class="bg-panel-background"
      *ngIf="{
        hasPremiumSubscription: hasPremiumSubscription$ | async,
        inputMode: inputMode$ | async
      } as searchRowInfo"
    >
      <td class="route-add-stop-search-cell">
        <span class="">Add Stop</span>
      </td>
      <td>
        <div class="d-flex py-2 pr-2 pl-1 align-items-center">
          <div
            class="flex-grow-1 mr-2"
            *ngIf="searchRowInfo.inputMode === inputModeEnum.Search"
          >
            <app-single-search
              (startSearch)="addStop($event)"
            ></app-single-search>
          </div>
          <div
            class="flex-grow-1 mr-2"
            *ngIf="
              searchRowInfo.inputMode === inputModeEnum.Favorites &&
              searchRowInfo.hasPremiumSubscription
            "
          >
            <app-favorite-place
              [isFavorite]="true"
              (selectedPlace)="addStop($event)"
            ></app-favorite-place>
          </div>
          <div
            class="flex-grow-1 mr-2"
            *ngIf="
              searchRowInfo.inputMode === inputModeEnum.CustomPlaces &&
              searchRowInfo.hasPremiumSubscription
            "
          >
            <app-custom-place
              (selectedPlace)="addStops($event)"
            ></app-custom-place>
          </div>
          <button
            *ngIf="!searchRowInfo.hasPremiumSubscription"
            type="button"
            class="btn btn-icon-only mr-1"
            data-toggle="tooltip"
            data-placement="top"
            [adaptivePosition]="false"
            tooltip="Favorite Place is Premium Only"
            container="body"
          >
            <i class="modus-icon material-icons">star</i>
          </button>
          <button
            *ngIf="!searchRowInfo.hasPremiumSubscription"
            type="button"
            class="btn btn-icon-only mr-1"
            data-toggle="tooltip"
            [adaptivePosition]="false"
            data-placement="top"
            tooltip="Custom Place is Premium Only"
            container="body"
          >
            <i class="modus-icons">map_marker</i>
          </button>
          <button
            *ngIf="searchRowInfo.hasPremiumSubscription"
            class="btn btn-icon-only mr-1"
            tooltip="Favorites"
            container="body"
            [adaptivePosition]="false"
            placement="bottom"
            (click)="changeInputMode(inputModeEnum.Favorites)"
            [ngClass]="{
              'bg-gray-1': searchRowInfo.inputMode === inputModeEnum.Favorites,
              'btn-text-dark':
                searchRowInfo.inputMode !== inputModeEnum.Favorites
            }"
          >
            <i class="modus-icon material-icons">star</i>
          </button>
          <button
            *ngIf="searchRowInfo.hasPremiumSubscription"
            class="btn btn-icon-only btn-text-dark"
            tooltip="Custom Places"
            container="body"
            [adaptivePosition]="false"
            (click)="changeInputMode(inputModeEnum.CustomPlaces)"
            placement="bottom"
            [ngClass]="{
              'bg-gray-1':
                searchRowInfo.inputMode === inputModeEnum.CustomPlaces,
              'btn-text-dark':
                searchRowInfo.inputMode !== inputModeEnum.CustomPlaces
            }"
          >
            <i class="modus-icons">map_marker</i>
          </button>
        </div>
      </td>
    </tr>
  </ng-container>
</table>
<table
  *ngIf="{
    routeOptionsData: routeList$ | async,
    appSettingsData: appSettingsData$ | async,
    isEuRegion: isEuRegion$ | async,
    precision: precision$ | async
  } as p"
  class="w-100"
  cdkDropList
  [cdkDropListDisabled]="
    (routeEditMode$ | async) === routeEditModeEnum.EditStopOptions
  "
  (cdkDropListDropped)="drop($event)"
>
  <!-- Route Stops -->
  <tr
    class="route-stop-row"
    *ngIf="
      (hasStops$ | async) &&
      (routeEditMode$ | async) === routeEditModeEnum.AddStop
    "
  >
    <th colspan="2"></th>
    <th class="route-stop-detail-cell">
      <span
        *ngIf="
          p.routeOptionsData?.optionsState.inclTollData !== 'undefined'
            ? p.routeOptionsData?.optionsState?.inclTollData
            : p.appSettingsData?.includeTollData && !p.isEuRegion
        "
        >Tolls</span
      >
    </th>
    <th class="route-stop-detail-cell">
      {{
        (p.routeOptionsData?.optionsState.distanceUnits !== "undefined"
          ? p.routeOptionsData?.optionsState?.distanceUnits
          : p.appSettingsData?.distanceUnits
        ) | distanceUnit
      }}
    </th>
    <th class="route-stop-detail-cell">Time</th>
    <th class="route-stop-detail-cell" *ngIf="hasEtaEtdValue && nbrStops > 1">
      ETA/ETD
    </th>
    <th class="route-stop-detail-cell"></th>
  </tr>
  <!-- Route Stops -->
  <tr
    cdkDrag
    app-stop-item
    class="route-stop-row"
    *ngFor="let stop of stopListWithwarn$ | async; let stopIndex = index"
    [ngClass]="{ animation: stop.highlightStop === true }"
    [stop]="stop"
    [precision]="p.precision"
    [showToll]="
      p.routeOptionsData?.optionsState.inclTollData !== 'undefined'
        ? p.routeOptionsData?.optionsState?.inclTollData
        : p.appSettingsData?.includeTollData && !p.isEuRegion
    "
    [stopIndex]="stop?.index"
    [displayCurrency]="displayCurrency"
    (delete)="deleteStop($event)"
    (centerStop)="centerStop($event)"
    (showReport)="showReport($event)"
    cdkDragLockAxis="y"
    [cdkDragDisabled]="stop?.type === 'warning'"
  >
    <ng-template cdkDragPreview [matchSize]="true">
      <tr class="route-stop-row">
        <td style="width: 38px">
          <span class="route-stop-line"></span>
          <span class="route-stop-circle"></span>
          <span class="route-stop-number"></span>
        </td>
        <td style="width: 257px" class="font-weight-bolder">Updating...</td>
        <td style="width: 50px"></td>
        <td style="width: 50px"></td>
        <td style="width: 100px"></td>
        <td *ngIf="hasEtaEtdValue" style="width: 100px"></td>
        <td class="route-stop-action">
          <span class="btn btn-icon-only btn-text-dark">
            <i class="modus-icons material-icons">more_vertical</i>
          </span>
        </td>
      </tr>
    </ng-template>
  </tr>
  <ng-container *ngIf="(routeEditMode$ | async) === routeEditModeEnum.AddStop">
    <!-- Totals Row -->
    <tr
      class="route-stop-totals bg-panel-background font-weight-bolder"
      *ngIf="routeTotals"
    >
      <td class="route-stop-icon-cell"></td>
      <td class="route-stop-detail-cell">
        TOTALS:
        {{ routeTotals.cost | displayCurrency : displayCurrency }}&#32;&#32;
      </td>
      <td class="route-stop-detail-cell">
        <span
          *ngIf="
            p.routeOptionsData?.optionsState.inclTollData !== 'undefined'
              ? p.routeOptionsData?.optionsState?.inclTollData
              : p.appSettingsData?.includeTollData &&
                !p.isEuRegion &&
                routeTotals?.tolls
          "
          >{{ routeTotals.tolls | displayCurrency : displayCurrency }}</span
        >
      </td>
      <td class="route-stop-detail-cell">
        {{ routeTotals.distance | precision : p.precision }}
      </td>
      <td class="route-stop-detail-cell">
        {{ routeTotals.time }}
      </td>
      <td class="route-stop-detail-cell" *ngIf="hasEtaEtdValue">&nbsp;</td>
      <td class="route-stop-detail-cell">&nbsp;</td>
    </tr>
  </ng-container>
  <ng-container
    *ngIf="(routeEditMode$ | async) === routeEditModeEnum.EditStopOptions"
  >
    <tr>
      <td colspan="6" class="p-2 border-top">
        <div class="float-right">
          <button
            type="button"
            class="btn btn-sm btn-primary m-1"
            (click)="saveEdit()"
            [disabled]="stopOptionsArray.invalid"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-dark m-1"
            (click)="cancelEdit()"
          >
            Cancel
          </button>
        </div>
      </td>
    </tr>
  </ng-container>
</table>
